import { gql } from "@apollo/client";

const UPDATE_SUBSCRIPTION_PLAN = gql`
  mutation UpdateSubscriptionPlan($input: UpdateSubscriptionPlanInput!) {
    updateSubscriptionPlan(input: $input) {
      subscription {
        status
        metaData
      }
    }
  }
`;

export default UPDATE_SUBSCRIPTION_PLAN;
